module.exports = __webpack_public_path__ + "static/img/zx-dhzx-icon.810e84c7.png";